import Axios from "./axios";
import { getUserId } from '../helpers/localStorage';

/* Master User Required */

export const getAllAgentIssuanceLogAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post('/logs/agent-issuance/all', { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const getAllCustomerActivityLogAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post('/logs/customer-activity/all', { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const getAllFloatInvoiceRequestLogAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post('/logs/float-invoice-request/all', { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const getAllIssuedCardLogAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post('/logs/issued-card/all', { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const getAllLoginAttemptsLogsAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post('/logs/all', { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const getAllUsersAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`user/all`, { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getAllWhiteListIpLogsAPI = ({ limit, page }) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`logs/ip-white-list/all`, { limit, page })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getCustomerDetailsAPI = (customerId) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`customer/details`, { tcnAdminCustomerId: customerId })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err?.response?.data?.err || err?.response?.data || err);
      });
  });
};

export const getGlobalSettingsAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`setting/global`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const updateGlobalSettingsAPI = (globalSettings) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`setting/global`, globalSettings)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

/* Admin User Required */

export const createDepartmentAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`department/create`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data?.err;
        return reject(error);
      });
  });
};

export const createIssuanceTypeAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`issuanceType/create`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data?.err;
        return reject(error);
      });
  });
};

export const createManageIpsAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`ipwhitelist/create`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data;
        return reject(error);
      });
  });
};

export const createNewUserAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`user/create`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getAllIssuanceTypeAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`issuanceType/all`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getAllUserLogsAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`user/logs`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getAllWhiteListIpsAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`ipwhitelist/all`, { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const updateAgentIssuanceAPI = (id, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`issuanceType`, { agentIssuanceId: id, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateDefaultAgentIssuanceTypeAPI = (id, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`issuanceType/setDefault`, { agentIssuanceId: id })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateDepartmentAPI = (id, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`department`, { departmentId: id, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateManageIpsAPI = (id, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`ipwhitelist`, { manageIpId: id, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateUserAPI = (userId, data) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`user`, { userId, ...data })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

/* Regular User Required */

export const blockCardInBulkAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/blockCardInBulk`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const cancelCardByProxyAPI = (cardProxy, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/cancel`, { cardProxy, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const createBulkCardAPI = (cards,) => {
  return Axios.post(`card/createInBulk`, cards)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      Promise.reject(err);
    });
};

export const createCardAPI = (data, isAgentIssuanceDigital) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/create${isAgentIssuanceDigital ? '?agentIssuanceDigital=true' : ''}`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data?.err;
        return reject(error);
      });
  });
};

export const getMasterUserDetailsAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`user/masterUser`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data;
        return reject(error);
      });
  });
};

export const floatRequestAPI = ({ amount, invoiceEmail, additionalEmail }) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`customer/float-request`, { amount, invoiceEmail, additionalEmail })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data;
        return reject(error);
      });
  });
};

export const replaceCardAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`card/replaceCard`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const resendEmailAPI = (data) => {
  const payload = { cardId: data.cardId, email: data.email };

  return new Promise(function (resolve, reject) {
    Axios.post(`card/resendEmail`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const updateAgentIssueAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`card/agentissuecard`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateBulkAgentIssueAPI = (data, viewFile) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`card/agentissuecard/bulk${viewFile ? '?view_file=true' : ''}`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const updateCardStatusAPI = (cardId, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/updateCardStatus`, { cardId, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const validateBulkCardAPI = (formdata) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/bulkIssue`, formdata)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data;
        return reject(error);
      });
  });
};

/* Readonly User Required */

export const exportAgentIssuanceDataAPI = (data, isAvailableCard) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`cardIssuance/exportdata${isAvailableCard ? '?key=availablecard' : '?key=issuedcard'}`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const exportCampaignDataAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`campaign/exportdata`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const exportCardsDataAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/exportdata`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getAllDepartmentsAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`department/all`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getAllIssuanceTypeAssoDepartmentAPI = (departmentId) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`issuanceType/department`, { departmentId })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCardAPI = (cardId) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card`, { cardId })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getCardByProxyAPI = (cardProxy) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/proxy`, { cardProxy })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getCardLiveTransactionAPI = (cardProxy) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/getLiveTransactions`, { cardProxy })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCardNoteAPI = (cardId) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/notes`, { cardId })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCardsAPI = (data, agentIssuanceFlag) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/getCards${agentIssuanceFlag ? '?agentIssuanceFlag=true' : ''}`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCardTransactionAPI = (cardProxy) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/getCardTransaction`, { cardProxy })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCustomerInfoAPI = async () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`user`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const getPromotionDataAPI = (data) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`campaign/getPromotionData`, data)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data?.err;
        return reject(error);
      });
  });
};

export const getSubUsersAPI = ({ limit, page, filter }) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`user/subUsers`, { limit, page, filter })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const sendCardNoteAPI = (cardId, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/note`, { cardId, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const updateCardAdditionalInfoAPI = (proxy, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`card/proxy/additionalInfo`, { cardProxy: proxy, ...payload })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

/* Auth APIs */

export const crownSsoLoginAPI = (azureToken) => {
  return new Promise(function (resolve, reject) {
    Axios.get(`auth/crown/login`, {
      headers: {
        'azure-token': azureToken
      }
    })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const forgotPasswordAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`auth/forget-password`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || {
            errormessage: 'Something went wrong !!!'
          }
        );
      });
  });
};

export const generateOtpAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`auth/otp`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getUserMfaInfoAPI = () => {
  return new Promise(function (resolve, reject) {
    Axios.get(`user/mfainfo`, {})
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const loginAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`auth/login`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const mfaVerifyAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`auth/2fa/verify`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export const otpVerifyAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`auth/otp/verify`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const resetPasswordAPI = (token, payload) => {
  return new Promise(function (resolve, reject) {
    Axios.put(`auth/reset-password/${token}`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const verifyResetPasswordTokenAPI = (token) => {
  return new Promise(function (resolve, reject) {
    Axios.get(`auth/verify-reset-password-token/${token}`)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

/* Custom Redeem API */

export const createSwapAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`swap/create`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const createUatSwapAPI = (payload) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`swap/uat/create`, payload)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        return reject(
          err?.response?.data || { errormessage: 'Something went wrong !!!' }
        );
      });
  });
};

export const getCardByIdentifierAPI = (identifier) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/identifier`, { identifier })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};

export const getCardByIdentifierInUatAPI = (identifier) => {
  return new Promise(function (resolve, reject) {
    Axios.post(`card/identifier`, { identifier })
      .then((response) => {
        return resolve(response.data);
      })
      .catch((err) => {
        const error = err?.response?.data || {
          errormessage: 'Something went wrong !!!'
        };
        return reject(error);
      });
  });
};